import { createFileRoute } from '@tanstack/react-router'
import { UserProfilePage } from '../../../../components/UserProfilePage'
import { useAuth } from '../../../../hooks/useAuth'

export const Route = createFileRoute('/$org/user/me/profile')({
    component: UserProfileRoute,
})

function UserProfileRoute() {
    const { org } = Route.useParams()
    const { user } = useAuth()

    return <UserProfilePage orgCode={org} userUid={user?.uid} />
}
